{
  "about.contact": "ਸੰਪਰਕ:",
  "about.default_locale": "ਮੂਲ",
  "about.disclaimer": "ਮਸਟੋਡੋਨ ਇੱਕ ਆਜ਼ਾਦ, ਖੁੱਲ੍ਹੇ ਸਰੋਤ ਵਾਲਾ ਸਾਫਟਵੇਅਰ ਹੈ ਅਤੇ Mastodon gGmbH ਦਾ ਮਾਰਕਾ ਹੈ।",
  "about.domain_blocks.no_reason_available": "ਕਾਰਨ ਮੌਜੂਦ ਨਹੀਂ ਹੈ",
  "about.domain_blocks.silenced.title": "ਸੀਮਿਤ",
  "about.domain_blocks.suspended.title": "ਸਸਪੈਂਡ ਕੀਤਾ",
  "about.language_label": "ਭਾਸ਼ਾ",
  "about.not_available": "ਇਹ ਜਾਣਕਾਰੀ ਨੂੰ ਇਸ ਸਰਵਰ ਉੱਤੇ ਉਪਲੱਬਧ ਨਹੀਂ ਕੀਤਾ ਗਿਆ ਹੈ।",
  "about.rules": "ਸਰਵਰ ਨਿਯਮ",
  "account.account_note_header": "ਨਿੱਜੀ ਨੋਟ",
  "account.activity": "ਸਰਗਰਮੀ",
  "account.add_note": "ਕੋਈ ਨਿੱਜੀ ਨੋਟ ਜੋੜੋ",
  "account.add_or_remove_from_list": "ਸੂਚੀ ਵਿੱਚ ਜੋੜੋ ਜਾਂ ਹਟਾਓ",
  "account.badges.admin": "ਪ੍ਰਸ਼ਾਸਕ",
  "account.badges.blocked": "ਪਾਬੰਦੀਸ਼ੁਦਾ",
  "account.badges.bot": "ਆਟੋਮੇਟ ਕੀਤਾ",
  "account.badges.domain_blocked": "ਪਾਬੰਦੀ ਲਾਏ ਡੋਮੇਨ",
  "account.badges.group": "ਗਰੁੱਪ",
  "account.badges.muted": "ਮੌਨ ਕੀਤੇ",
  "account.badges.muted_until": "{until} ਤੱਕ ਮੌਨ ਕੀਤੇ",
  "account.block": "@{name} ਉੱਤੇ ਪਾਬੰਦੀ ਲਾਓ",
  "account.block_domain": "{domain} ਡੋਮੇਨ ਉੱਤੇ ਪਾਬੰਦੀ ਲਾਓ",
  "account.block_short": "ਪਾਬੰਦੀ",
  "account.blocked": "ਪਾਬੰਦੀਸ਼ੁਦਾ",
  "account.cancel_follow_request": "ਫ਼ਾਲੋ ਕਰਨ ਨੂੰ ਰੱਦ ਕਰੋ",
  "account.copy": "ਪਰੋਫਾਇਲ ਲਈ ਲਿੰਕ ਕਾਪੀ ਕਰੋ",
  "account.direct": "ਨਿੱਜੀ ਜ਼ਿਕਰ @{name}",
  "account.disable_notifications": "ਜਦੋਂ {name} ਕੋਈ ਪੋਸਟ ਕਰੇ ਤਾਂ ਮੈਨੂੰ ਸੂਚਨਾ ਨਾ ਦਿਓ",
  "account.edit_note": "ਨਿੱਜੀ ਨੋਟ ਨੂੰ ਸੋਧੋ",
  "account.edit_profile": "ਪਰੋਫਾਈਲ ਨੂੰ ਸੋਧੋ",
  "account.edit_profile_short": "ਸੋਧੋ",
  "account.enable_notifications": "ਜਦੋਂ {name} ਪੋਸਟ ਕਰੇ ਤਾਂ ਮੈਨੂੰ ਸੂਚਨਾ ਦਿਓ",
  "account.endorse": "ਪਰੋਫਾਇਲ ਉੱਤੇ ਫ਼ੀਚਰ",
  "account.familiar_followers_one": "{name1} ਵਲੋਂ ਫ਼ਾਲੋ ਕੀਤਾ",
  "account.familiar_followers_two": "{name1} ਅਤੇ {name2} ਵਲੋਂ ਫ਼ਾਲੋ ਕੀਤਾ",
  "account.featured": "ਫ਼ੀਚਰ",
  "account.featured.accounts": "ਪਰੋਫਾਈਲ",
  "account.filters.all": "ਸਾਰੀਆਂ ਸਰਗਰਮੀਆਂ",
  "account.filters.posts_only": "ਪੋਸਟਾਂ",
  "account.filters.posts_replies": "ਪੋਸਟਾਂ ਅਤੇ ਜਵਾਬ",
  "account.filters.replies_toggle": "ਜਵਾਬਾਂ ਨੂੰ ਵੇਖੋ",
  "account.follow": "ਫ਼ਾਲੋ",
  "account.follow_back": "ਵਾਪਸ ਫਾਲ਼ੋ ਕਰੋ",
  "account.follow_back_short": "ਵਾਪਸ ਫਾਲ਼ੋ ਕਰੋ",
  "account.follow_request": "ਫ਼ਾਲੋ ਕਰਨ ਦੀ ਬੇਨਤੀ",
  "account.follow_request_cancel": "ਮੰਗ ਰੱਦ ਕਰੋ",
  "account.follow_request_cancel_short": "ਰੱਦ ਕਰੋ",
  "account.follow_request_short": "ਬੇਨਤੀ",
  "account.followers": "ਫ਼ਾਲੋਅਰ",
  "account.followers.empty": "ਇਸ ਵਰਤੋਂਕਾਰ ਨੂੰ ਹਾਲੇ ਕੋਈ ਫ਼ਾਲੋ ਨਹੀਂ ਕਰਦਾ ਹੈ।",
  "account.followers_counter": "{count, plural, one {{counter} ਫ਼ਾਲੋਅਰ} other {{counter} ਫ਼ਾਲੋਅਰ}}",
  "account.followers_you_know_counter": "{counter} ਤੁਸੀਂ ਜਾਣਦੇ ਹੋ",
  "account.following": "ਫ਼ਾਲੋ ਕੀਤਾ",
  "account.follows.empty": "ਇਹ ਵਰਤੋਂਕਾਰ ਹਾਲੇ ਕਿਸੇ ਨੂੰ ਫ਼ਾਲੋ ਨਹੀਂ ਕਰਦਾ ਹੈ।",
  "account.follows_you": "ਤੁਹਾਨੂੰ ਫ਼ਾਲੋ ਕਰਦੇ ਹਨ",
  "account.go_to_profile": "ਪਰੋਫਾਇਲ ਉੱਤੇ ਜਾਓ",
  "account.hide_reblogs": "{name} ਵਲੋਂ ਬੂਸਟ ਨੂੰ ਲੁਕਾਓ",
  "account.joined_short": "ਜੁਆਇਨ ਕੀਤਾ",
  "account.media": "ਮੀਡੀਆ",
  "account.mention": "@{name} ਦਾ ਜ਼ਿਕਰ",
  "account.menu.block": "ਖਾਤੇ ਉੱਤੇ ਪਾਬੰਦੀ ਲਾਓ",
  "account.menu.block_domain": "{domain} ਉੱਤੇ ਪਾਬੰਦੀ ਲਾਓ",
  "account.menu.copied": "ਖਾਤਾ ਲਿੰਕ ਨੂੰ ਕਲਿੱਪਬੋਰਡ ਨੂੰ ਕਾਪੀ ਕੀਤਾ",
  "account.menu.copy": "ਲਿੰਕ ਨੂੰ ਕਾਪੀ ਕਰੋ",
  "account.menu.direct": "ਨਿੱਜੀ ਜ਼ਿਕਰ",
  "account.menu.mention": "ਜ਼ਿਕਰ",
  "account.menu.mute": "ਖਾਤੇ ਨੂੰ ਮੌਨ ਕਰੋ",
  "account.menu.open_original_page": "{domain} ਉੱਤੇ ਵੇਖੋ",
  "account.menu.remove_follower": "ਫ਼ਾਲੋਅਰ ਨੂੰ ਹਟਾਓ",
  "account.menu.report": "ਖਾਤੇ ਬਾਰੇ ਰਿਪੋਰਟ ਕਰੋ",
  "account.menu.share": "…ਸਾਂਝਾ ਕਰੋ",
  "account.menu.unblock": "ਖਾਤੇ ਉੱਤੇ ਪਾਬੰਦੀ ਨੂੰ ਹਟਾਓ",
  "account.menu.unblock_domain": "{domain} ਤੋਂ ਪਾਬੰਦੀ ਨੂੰ ਹਟਾਓ",
  "account.mute": "{name} ਨੂੰ ਮੌਨ ਕਰੋ",
  "account.mute_notifications_short": "ਨੋਟਫਿਕੇਸ਼ਨਾਂ ਨੂੰ ਮੌਨ ਕਰੋ",
  "account.mute_short": "ਮੌਨ ਕਰੋ",
  "account.muted": "ਮੌਨ ਕੀਤੀਆਂ",
  "account.mutual": "ਤੁਸੀਂ ਇੱਕ ਦੂਜੇ ਨੂੰ ਫ਼ਾਲੋ ਕਰਦੇ ਹੋ",
  "account.no_bio": "ਕੋਈ ਵਰਣਨ ਨਹੀਂ ਦਿੱਤਾ।",
  "account.node_modal.edit_title": "ਨਿੱਜੀ ਨੋਟ ਨੂੰ ਸੋਧੋ",
  "account.node_modal.field_label": "ਨਿੱਜੀ ਨੋਟ",
  "account.node_modal.save": "ਸੰਭਾਲੋ",
  "account.node_modal.title": "ਕੋਈ ਨਿੱਜੀ ਨੋਟ ਜੋੜੋ",
  "account.note.edit_button": "ਸੋਧੋ",
  "account.note.title": "ਨਿੱਜੀ ਨੋਟ (ਸਿਰਫ਼ ਤੁਹਾਨੂੰ ਹੀ ਦਿਖਾਈ ਦਿੰਦਾ ਹੈ)",
  "account.open_original_page": "ਅਸਲ ਸਫ਼ੇ ਨੂੰ ਖੋਲ੍ਹੋ",
  "account.posts": "ਪੋਸਟਾਂ",
  "account.remove_from_followers": "{name} ਨੂੰ ਫ਼ਾਲੋਅਰ ਵਿੱਚੋਂ ਹਟਾਓ",
  "account.report": "{name} ਬਾਰੇ ਰਿਪੋਰਟ ਕਰੋ",
  "account.requested_follow": "{name} ਨੇ ਤੁਹਾਨੂੰ ਫ਼ਾਲੋ ਕਰਨ ਦੀ ਬੇਨਤੀ ਕੀਤੀ ਹੈ",
  "account.share": "{name} ਦਾ ਪਰੋਫ਼ਾਇਲ ਸਾਂਝਾ ਕਰੋ",
  "account.show_reblogs": "@{name} ਵਲੋਂ ਬੂਸਟ ਨੂੰ ਵੇਖਾਓ",
  "account.statuses_counter": "{count, plural, one {{counter} ਪੋਸਟ} other {{counter} ਪੋਸਟਾਂ}}",
  "account.timeline.pinned": "ਟੰਗੇ ਹੋਏ",
  "account.timeline.pinned.view_all": "ਸਭ ਟੰਗੀਆਂ ਹੋਈਆਂ ਪੋਸਟਾਂ ਨੂੰ ਵੇਖੋ",
  "account.unblock": "@{name} ਤੋਂ ਪਾਬੰਦੀ ਹਟਾਓ",
  "account.unblock_domain": "{domain} ਡੋਮੇਨ ਤੋਂ ਪਾਬੰਦੀ ਹਟਾਓ",
  "account.unblock_domain_short": "ਪਾਬੰਦੀ ਹਟਾਓ",
  "account.unblock_short": "ਪਾਬੰਦੀ ਹਟਾਓ",
  "account.unendorse": "ਪਰੋਫਾਇਲ ਉੱਤੇ ਫ਼ੀਚਰ ਨਾ ਕਰੋ",
  "account.unfollow": "ਅਣ-ਫ਼ਾਲੋ",
  "account.unmute": "@{name} ਲਈ ਮੌਨ ਹਟਾਓ",
  "account.unmute_notifications_short": "ਨੋਟਫਿਕੇਸ਼ਨਾਂ ਨੂੰ ਅਣ-ਮੌਨ ਕਰੋ",
  "account.unmute_short": "ਮੌਨ-ਰਹਿਤ ਕਰੋ",
  "account_note.placeholder": "Click to add a note",
  "admin.dashboard.retention.average": "ਔਸਤ",
  "admin.dashboard.retention.cohort_size": "ਨਵੇਂ ਵਰਤੋਂਕਾਰ",
  "alert.unexpected.title": "ਓਹੋ!",
  "alt_text_badge.title": "ਬਦਲੀ ਲਿਖਤ",
  "alt_text_modal.add_alt_text": "ਬਦਲਵੀ ਲਿਖਤ ਨੂੰ ਜੋੜੋ",
  "alt_text_modal.cancel": "ਰੱਦ ਕਰੋ",
  "alt_text_modal.done": "ਮੁਕੰਮਲ",
  "announcement.announcement": "ਹੋਕਾ",
  "annual_report.announcement.action_dismiss": "ਨਹੀਂ, ਧੰਨਵਾਦ",
  "annual_report.nav_item.badge": "ਨਵਾਂ",
  "annual_report.shared_page.donate": "ਦਾਨ ਕਰੋ",
  "annual_report.summary.archetype.die_drei_fragezeichen": "???",
  "annual_report.summary.close": "ਬੰਦ ਕਰੋ",
  "annual_report.summary.copy_link": "ਲਿੰਕ ਨੂੰ ਕਾਪੀ ਕਰੋ",
  "annual_report.summary.followers.new_followers": "{count, plural, one {ਨਵਾਂ ਫ਼ਾਲੋਅਰ} other {ਨਵੇਂ ਫ਼ਾਲੋਅਰ}}",
  "annual_report.summary.highlighted_post.title": "ਸਭ ਤੋਂ ਵੱਧ ਹਰਮਨਪਿਆਰੀ ਪੋਸਟ",
  "annual_report.summary.most_used_app.most_used_app": "ਸਭ ਤੋਂ ਵੱਧ ਵਰਤੀ ਐਪ",
  "annual_report.summary.new_posts.new_posts": "ਨਵੀਆਂ ਪੋਸਟਾਂ",
  "audio.hide": "ਆਡੀਓ ਨੂੰ ਲੁਕਾਓ",
  "block_modal.show_less": "ਘੱਟ ਦਿਖਾਓ",
  "block_modal.show_more": "ਵੱਧ ਦਿਖਾਓ",
  "block_modal.title": "ਵਰਤੋਂਕਾਰ ਉੱਤੇ ਪਾਬੰਦੀ ਲਾਉਣੀ ਹੈ?",
  "boost_modal.reblog": "ਪੋਸਟ ਨੂੰ ਬੂਸਟ ਕਰਨਾ ਹੈ?",
  "bundle_column_error.copy_stacktrace": "ਗਲਤੀ ਰਿਪੋਰਟ ਨੂੰ ਕਾਪੀ ਕਰੋ",
  "bundle_column_error.error.title": "ਓਹ ਹੋ!",
  "bundle_column_error.network.title": "ਨੈੱਟਵਰਕ ਦੀ ਸਮੱਸਿਆ",
  "bundle_column_error.retry": "ਮੁੜ-ਕੋਸ਼ਿਸ਼ ਕਰੋ",
  "bundle_column_error.return": "ਵਾਪਸ ਮੁੱਖ ਸਫ਼ੇ ਉੱਤੇ ਜਾਓ",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "ਬੰਦ ਕਰੋ",
  "bundle_modal_error.retry": "ਮੁੜ-ਕੋਸ਼ਿਸ਼ ਕਰੋ",
  "callout.dismiss": "ਖ਼ਾਰਜ ਕਰੋ",
  "carousel.current": "<sr>ਸਲਾਈਡ</sr> {current, number} / {max, number}",
  "carousel.slide": "{max, number} ਵਿੱਚੋਂ {current, number} ਸਲਾਈਡ",
  "closed_registrations_modal.find_another_server": "ਹੋਰ ਸਰਵਰ ਲੱਭੋ",
  "closed_registrations_modal.title": "Mastodon ਲਈ ਸਾਈਨ ਅੱਪ ਕਰੋ",
  "collections.collection_description": "ਵਰਣਨ",
  "collections.collection_name": "ਨਾਂ",
  "collections.collection_topic": "ਵਿਸ਼ਾ",
  "collections.content_warning": "ਸਮੱਗਰੀ ਬਾਰੇ ਚੇਤਾਵਨੀ",
  "collections.continue": "ਜਾਰੀ ਰੱਖੋ",
  "collections.create.basic_details_title": "ਮੁ਼ੱਢਲੇ ਵੇਰਵੇ",
  "collections.create.steps": "ਪੜਾਅ {step}/{total}",
  "collections.view_collection": "ਭੰਡਾਰ ਨੂੰ ਵੇਖੋ",
  "collections.visibility_public": "ਜਨਤਕ",
  "collections.visibility_title": "ਦਿੱਖ",
  "column.about": "ਸਾਡੇ ਬਾਰੇ",
  "column.blocks": "ਪਾਬੰਦੀ ਲਾਏ ਵਰਤੋਂਕਾਰ",
  "column.bookmarks": "ਬੁੱਕਮਾਰਕ",
  "column.community": "ਲੋਕਲ ਸਮਾਂ-ਲਾਈਨ",
  "column.create_list": "ਸੂਚੀ ਬਣਾਓ",
  "column.direct": "ਨਿੱਜੀ ਜ਼ਿਕਰ",
  "column.directory": "ਪ੍ਰੋਫਾਈਲਾਂ ਨੂੰ ਦੇਖੋ",
  "column.domain_blocks": "ਪਾਬੰਦੀ ਲਾਏ ਡੋਮੇਨ",
  "column.edit_list": "ਸੂਚੀ ਨੂੰ ਸੋਧੋ",
  "column.favourites": "ਮਨਪਸੰਦ",
  "column.firehose": "ਲਾਈਵ ਫੀਡ",
  "column.firehose_singular": "ਲਾਈਵ ਫੀਡ",
  "column.follow_requests": "ਫ਼ਾਲੋ ਦੀਆਂ ਬੇਨਤੀਆਂ",
  "column.home": "ਮੁੱਖ ਸਫ਼ਾ",
  "column.list_members": "ਸੂਚੀ ਦੇ ਮੈਂਬਰ ਦਾ ਇੰਤਜ਼ਾਮ ਕਰੋ",
  "column.lists": "ਸੂਚੀਆਂ",
  "column.mutes": "ਮੌਨ ਕੀਤੇ ਵਰਤੋਂਕਾਰ",
  "column.notifications": "ਸੂਚਨਾਵਾਂ",
  "column.pins": "ਟੰਗੀਆਂ ਪੋਸਟਾਂ",
  "column_back_button.label": "ਪਿੱਛੇ",
  "column_header.hide_settings": "ਸੈਟਿੰਗਾਂ ਨੂੰ ਲੁਕਾਓ",
  "column_header.moveLeft_settings": "ਕਾਲਮ ਨੂੰ ਖੱਬੇ ਪਾਸੇ ਭੇਜੋ",
  "column_header.moveRight_settings": "ਕਾਲਮ ਨੂੰ ਸੱਜੇ ਪਾਸੇ ਭੇਜੋ",
  "column_header.pin": "ਟੰਗੋ",
  "column_header.show_settings": "ਸੈਟਿੰਗਾਂ ਦਿਖਾਓ",
  "column_header.unpin": "ਲਾਹੋ",
  "column_search.cancel": "ਰੱਦ ਕਰੋ",
  "combobox.loading": "ਲੋਡ ਹੋ ਰਿਹਾ ਹੈ",
  "combobox.no_results_found": "ਇਸ ਖੋਜ ਲਈ ਕੋਈ ਨਤੀਜੇ ਨਹੀਂ ਹਨ",
  "combobox.open_results": "ਨਤੀਜਿਆਂ ਨੂੰ ਵੇਖੋ",
  "community.column_settings.local_only": "ਸਿਰਫ ਲੋਕਲ ਹੀ",
  "community.column_settings.media_only": "ਸਿਰਫ ਮੀਡੀਆ ਹੀ",
  "community.column_settings.remote_only": "ਸਿਰਫ਼ ਰਿਮੋਟ ਹੀ",
  "compose.error.blank_post": "ਪੋਸਟ ਖਾਲੀ ਨਹੀਂ ਹੋ ਸਕਦੀ ਹੈ।",
  "compose.language.change": "ਭਾਸ਼ਾ ਬਦਲੋ",
  "compose.language.search": "ਭਾਸ਼ਾਵਾਂ ਦੀ ਖੋਜ...",
  "compose.published.body": "ਪੋਸਟ ਪ੍ਰਕਾਸ਼ਿਤ ਕੀਤੀ।",
  "compose.published.open": "ਖੋਲ੍ਹੋ",
  "compose.saved.body": "ਪੋਸਟ ਸੰਭਾਲੀ ਗਈ।",
  "compose_form.direct_message_warning_learn_more": "ਹੋਰ ਜਾਣੋ",
  "compose_form.encryption_warning": "Posts on Mastodon are not end-to-end encrypted. Do not share any dangerous information over Mastodon.",
  "compose_form.hashtag_warning": "This post won't be listed under any hashtag as it is unlisted. Only public posts can be searched by hashtag.",
  "compose_form.lock_disclaimer": "ਤੁਹਾਡਾ ਖਾਤਾ {locked} ਨਹੀਂ ਹੈ। ਕੋਈ ਵੀ ਤੁਹਾਡੀਆਂ ਸਿਰਫ਼-ਫ਼ਾਲੋਅਰ ਪੋਸਟਾਂ ਵੇਖਣ ਵਾਸਤੇ ਤੁਹਾਨੂੰ ਫ਼ਾਲੋ ਕਰ ਸਕਦਾ ਹੈ।",
  "compose_form.lock_disclaimer.lock": "ਲਾਕ ਹੈ",
  "compose_form.placeholder": "ਤੁਹਾਡੇ ਮਨ ਵਿੱਚ ਕੀ ਹੈ?",
  "compose_form.poll.duration": "ਵੋਟ ਲਈ ਸਮਾਂ",
  "compose_form.poll.multiple": "ਕਈ ਚੋਣਾਂ",
  "compose_form.poll.option_placeholder": "{number} ਚੋਣ",
  "compose_form.poll.single": "ਇਕੱਲੀ ਚੋਣ",
  "compose_form.poll.type": "ਸਟਾਈਲ",
  "compose_form.publish": "ਪੋਸਟ",
  "compose_form.reply": "ਜਵਾਬ ਦਿਓ",
  "compose_form.save_changes": "ਅੱਪਡੇਟ",
  "compose_form.spoiler.marked": "ਸਮੱਗਰੀ ਚੇਤਾਵਨੀ ਨੂੰ ਹਟਾਓ",
  "compose_form.spoiler.unmarked": "ਸਮੱਗਰੀ ਬਾਰੇ ਚੇਤਾਵਨੀ ਜੋੜੋ",
  "compose_form.spoiler_placeholder": "ਸਮੱਗਰੀ ਬਾਰੇ ਚੇਤਾਵਨੀ (ਚੋਣਵਾਂ)",
  "confirmation_modal.cancel": "ਰੱਦ ਕਰੋ",
  "confirmations.block.confirm": "ਪਾਬੰਦੀ",
  "confirmations.delete.confirm": "ਹਟਾਓ",
  "confirmations.delete.message": "ਕੀ ਤੁਸੀਂ ਇਹ ਪੋਸਟ ਨੂੰ ਹਟਾਉਣਾ ਚਾਹੁੰਦੇ ਹੋ?",
  "confirmations.delete.title": "ਪੋਸਟ ਨੂੰ ਹਟਾਉਣਾ ਹੈ?",
  "confirmations.delete_collection.confirm": "ਹਟਾਓ",
  "confirmations.delete_collection.message": "ਇਸ ਕਾਰਵਾਈ ਨੂੰ ਵਾਪਸ ਨਹੀਂ ਪਰਤਾਇਆ ਜਾ ਸਕਦਾ ਹੈ।",
  "confirmations.delete_collection.title": "\"{name}\" ਨੂੰ ਹਟਾਉਣਾ ਹੈ?",
  "confirmations.delete_list.confirm": "ਹਟਾਓ",
  "confirmations.delete_list.message": "ਕੀ ਤੁਸੀਂ ਇਸ ਸੂਚੀ ਨੂੰ ਪੱਕੇ ਤੌਰ ਉੱਤੇ ਹਟਾਉਣਾ ਚਾਹੁੰਦੇ ਹੋ?",
  "confirmations.delete_list.title": "ਸੂਚੀ ਨੂੰ ਹਟਾਉਣਾ ਹੈ?",
  "confirmations.discard_draft.confirm": "ਖ਼ਾਰਜ ਕਰਕੇ ਜਾਰੀ ਰੱਖੋ",
  "confirmations.discard_draft.edit.cancel": "ਸੋਧਣਾ ਜਾਰੀ ਰੱਖੋ",
  "confirmations.discard_draft.post.cancel": "ਖਰੜੇ ਉੱਤੇ ਕੰਮ ਜਾਰੀ ਰੱਖੋ",
  "confirmations.discard_edit_media.confirm": "ਰੱਦ ਕਰੋ",
  "confirmations.follow_to_list.confirm": "ਫ਼ਾਲੋ ਕਰੋ ਅਤੇ ਲਿਸਟ 'ਚ ਜੋੜੋ",
  "confirmations.follow_to_list.title": "ਵਰਤੋਂਕਾਰ ਨੂੰ ਫ਼ਾਲੋ ਕਰਨਾ ਹੈ?",
  "confirmations.logout.confirm": "ਬਾਹਰ ਹੋਵੋ",
  "confirmations.logout.message": "ਕੀ ਤੁਸੀਂ ਲਾਗ ਆਉਟ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹੋ?",
  "confirmations.logout.title": "ਲਾਗ ਆਉਟ ਕਰਨਾ ਹੈ?",
  "confirmations.missing_alt_text.confirm": "ਬਦਲਵੀ ਲਿਖਤ ਨੂੰ ਜੋੜੋ",
  "confirmations.missing_alt_text.secondary": "ਕਿਵੇਂ ਵੀ ਪੋਸਟ ਕਰੋ",
  "confirmations.missing_alt_text.title": "ਬਦਲਵੀ ਲਿਖਤ ਜੋੜਨੀ ਹੈ?",
  "confirmations.mute.confirm": "ਮੌਨ ਕਰੋ",
  "confirmations.private_quote_notify.cancel": "ਸੋਧ ਕਰਨ ਉੱਤੇ ਵਾਪਸ ਜਾਓ",
  "confirmations.private_quote_notify.confirm": "ਜਨਤਕ ਪੋਸਟ",
  "confirmations.private_quote_notify.do_not_show_again": "ਮੈਨੂੰ ਇਹ ਸੁਨੇਹਾ ਫੇਰ ਨਾ ਦਿਖਾਓ",
  "confirmations.quiet_post_quote_info.dismiss": "ਮੈਨੂੰ ਮੁੜ ਕੇ ਯਾਦ ਨਾ ਕਰਵਾਓ",
  "confirmations.quiet_post_quote_info.got_it": "ਸਮਝ ਗਏ",
  "confirmations.redraft.confirm": "ਹਟਾਓ ਤੇ ਮੁੜ-ਡਰਾਫਟ",
  "confirmations.redraft.title": "ਪੋਸਟ ਨੂੰ ਹਟਾ ਕੇ ਮੁੜ-ਡਰਾਫਟ ਕਰਨਾ ਹੈ?",
  "confirmations.remove_from_followers.confirm": "ਫ਼ਾਲੋਅਰ ਨੂੰ ਹਟਾਓ",
  "confirmations.remove_from_followers.title": "ਫ਼ਾਲੋਅਰ ਨੂੰ ਹਟਾਉਣਾ ਹੈ?",
  "confirmations.revoke_quote.confirm": "ਪੋਸਟ ਨੂੰ ਹਟਾਓ",
  "confirmations.revoke_quote.message": "ਇਸ ਕਾਰਵਾਈ ਨੂੰ ਵਾਪਸ ਨਹੀਂ ਪਰਤਾਇਆ ਜਾ ਸਕਦਾ ਹੈ।",
  "confirmations.revoke_quote.title": "ਪੋਸਟ ਨੂੰ ਹਟਾਉਣਾ ਹੈ?",
  "confirmations.unblock.confirm": "ਪਾਬੰਦੀ ਨੂੰ ਹਟਾਓ",
  "confirmations.unblock.title": "{name} ਤੋਂ ਪਾਬੰਦੀ ਹਟਾਉਣੀ ਹੈ?",
  "confirmations.unfollow.confirm": "ਅਣ-ਫ਼ਾਲੋ",
  "confirmations.unfollow.title": "{name} ਨੂੰ ਅਣ-ਫ਼ਾਲੋ ਕਰਨਾ ਹੈ?",
  "confirmations.withdraw_request.confirm": "ਬੇਨਤੀ ਵਾਪਸ ਲਵੋ",
  "content_warning.hide": "ਪੋਸਟ ਨੂੰ ਲੁਕਾਓ",
  "content_warning.show": "ਕਿਵੇਂ ਵੀ ਵੇਖਾਓ",
  "content_warning.show_more": "ਹੋਰ ਵੇਖਾਓ",
  "conversation.delete": "ਗੱਲਬਾਤ ਨੂੰ ਹਟਾਓ",
  "conversation.mark_as_read": "ਪੜ੍ਹੇ ਵਜੋਂ ਨਿਸ਼ਾਨੀ ਲਾਓ",
  "conversation.open": "ਗੱਲਬਾਤ ਨੂੰ ਵੇਖੋ",
  "conversation.with": "{names} ਨਾਲ",
  "copy_icon_button.copied": "ਕਲਿੱਪਬੋਰਡ 'ਤੇ ਕਾਪੀ ਕਰੋ",
  "copypaste.copied": "ਕਾਪੀ ਕੀਤਾ",
  "copypaste.copy_to_clipboard": "ਕਲਿੱਪਬੋਰਡ 'ਤੇ ਕਾਪੀ ਕਰੋ",
  "directory.local": "ਸਿਰਫ਼ {domain} ਤੋਂ",
  "directory.new_arrivals": "ਨਵੇਂ ਆਉਣ ਵਾਲੇ",
  "directory.recently_active": "ਸੱਜਰੇ ਸਰਗਰਮ",
  "disabled_account_banner.account_settings": "ਖਾਤੇ ਦੀਆਂ ਸੈਟਿੰਗਾਂ",
  "disabled_account_banner.text": "ਤੁਹਾਡਾ ਖਾਤਾ {disabledAccount} ਇਸ ਵੇਲੇ ਅਸਮਰੱਥ ਕੀਤਾ ਹੈ।",
  "dismissable_banner.dismiss": "ਰੱਦ ਕਰੋ",
  "domain_block_modal.block": "ਸਰਵਰ ਉੱਤੇ ਪਾਬੰਦੀ ਲਾਓ",
  "domain_block_modal.block_account_instead": "ਇਸ ਦੀ ਬਜਾਏ @{name} ਉੱਤੇ ਪਾਬੰਦੀ ਲਾਓ",
  "domain_block_modal.title": "ਡੋਮੇਨ ਉੱਤੇ ਪਾਬੰਦੀ ਲਾਉਣੀ ਹੈ?",
  "domain_pill.server": "ਸਰਵਰ",
  "domain_pill.their_handle": "ਇਹ ਹੈਂਡਲ:",
  "domain_pill.their_server": "ਉਹਨਾਂ ਦਾ ਡਿਜ਼ਿਟਲ ਘਰ, ਜਿੱਥੇ ਉਹਨਾਂ ਦੀਆਂ ਸਾਰੀਆਂ ਪੋਸਟਾਂ ਹੁੰਦੀਆਂ ਹਨ।",
  "domain_pill.username": "ਵਰਤੋਂਕਾਰ-ਨਾਂ",
  "domain_pill.whats_in_a_handle": "ਹੈਂਡਲ ਕੀ ਹੁੰਦਾ ਹੈ?",
  "domain_pill.your_handle": "ਤੁਹਾਡਾ ਹੈਂਡਲ:",
  "dropdown.empty": "ਕੋਈ ਚੋਣ ਕਰੋ",
  "embed.instructions": "ਹੇਠਲੇ ਕੋਡ ਨੂੰ ਕਾਪੀ ਕਰਕੇ ਆਪਣੀ ਵੈੱਬਸਾਈਟ ਉੱਤੇ ਇਸ ਪੋਸਟ ਨੂੰ ਇੰਬੈੱਡ ਕਰੋ।",
  "emoji_button.activity": "ਗਤੀਵਿਧੀ",
  "emoji_button.clear": "ਮਿਟਾਓ",
  "emoji_button.custom": "ਕਸਟਮ",
  "emoji_button.flags": "ਝੰਡੀਆਂ",
  "emoji_button.food": "ਖਾਣਾ-ਪੀਣਾ",
  "emoji_button.label": "ਇਮੋਜੀ ਪਾਓ",
  "emoji_button.nature": "ਕੁਦਰਤ",
  "emoji_button.not_found": "ਕੋਈ ਮਿਲਦਾ ਇਮੋਜ਼ੀ ਨਹੀਂ ਲੱਭਿਆ",
  "emoji_button.objects": "ਇਕਾਈ",
  "emoji_button.people": "ਲੋਕ",
  "emoji_button.recent": "ਅਕਸਰ ਵਰਤੇ",
  "emoji_button.search": "ਖੋਜ ਕਰੋ...",
  "emoji_button.search_results": "ਖੋਜ ਨਤੀਜੇ",
  "emoji_button.symbols": "ਚਿੰਨ੍ਹ",
  "emoji_button.travel": "ਸੈਰ ਸਪਾਟਾ ਤੇ ਥਾਵਾਂ",
  "empty_column.account_suspended": "ਖਾਤਾ ਸਸਪੈਂਡ ਕੀਤਾ",
  "empty_column.account_timeline": "ਇੱਥੇ ਕੋਈ ਪੋਸਟ ਨਹੀਂ ਹੈ!",
  "empty_column.account_unavailable": "ਪ੍ਰੋਫਾਈਲ ਅਣ-ਉਪਲਬਧ ਹੈ",
  "empty_column.blocks": "ਤੁਸੀਂ ਹਾਲੇ ਕਿਸੇ ਵਰਤੋਂਕਾਰ ਉੱਤੇ ਪਾਬੰਦੀ ਨਹੀਂ ਲਾਈ ਹੈ।",
  "empty_column.bookmarked_statuses": "ਤੁਸੀਂ ਹਾਲੇ ਕਿਸੇ ਵੀ ਪੋਸਟ ਨੂੰ ਬੁੱਕਮਾਰਕ ਨਹੀਂ ਕੀਤਾ ਹੈ। ਜਦੋਂ ਤੁਸੀਂ ਬੁੱਕਮਾਰਕ ਕੀਤਾ ਤਾਂ ਉਹ ਇੱਥੇ ਦਿਖਾਈ ਦਾਵੇਗਾ।",
  "empty_column.home": "ਤੁਹਾਡੀ ਟਾਈਮ-ਲਾਈਨ ਖਾਲੀ ਹੈ! ਇਸ ਨੂੰ ਭਰਨ ਲਈ ਹੋਰ ਲੋਕਾਂ ਨੂੰ ਫ਼ਾਲੋ ਕਰੋ।",
  "empty_column.list": "ਇਸ ਸੂਚੀ ਵਿੱਚ ਹਾਲੇ ਕੁਝ ਵੀ ਨਹੀਂ ਹੈ। ਜਦੋਂ ਇਸ ਸੂਚੀ ਦੇ ਮੈਂਬਰ ਨਵੀਆਂ ਪੋਸਟਾਂ ਪਾਉਂਦੇ ਹਨ ਤਾਂ ਉਹ ਇੱਥੇ ਦਿਖਾਈ ਦੇਣਗੀਆਂ।",
  "errors.unexpected_crash.report_issue": "ਮੁੱਦੇ ਦੀ ਰਿਪੋਰਟ ਕਰੋ",
  "explore.suggested_follows": "ਲੋਕ",
  "explore.title": "ਰੁਝਾਨ",
  "explore.trending_links": "ਖ਼ਬਰਾਂ",
  "explore.trending_statuses": "ਪੋਸਟਾਂ",
  "explore.trending_tags": "ਹੈਸ਼ਟੈਗ",
  "featured_carousel.header": "{count, plural, one {ਟੰਗੀ ਹੋਈ ਪੋਸਟ} other {ਟੰਗੀਆਂ ਹੋਈਆਂ ਪੋਸਟਾਂ}}",
  "featured_carousel.slide": "{max, number} ਵਿੱਚੋਂ {current, number} ਪੋਸਟ",
  "featured_tags.more_items": "+{count}",
  "filter_modal.added.expired_title": "ਫਿਲਟਰ ਦੀ ਮਿਆਦ ਪੁੱਗੀ!",
  "filter_modal.added.review_and_configure_title": "ਫਿਲਟਰ ਸੈਟਿੰਗਾਂ",
  "filter_modal.added.settings_link": "ਸੈਟਿੰਗਾਂ ਸਫ਼ਾ",
  "filter_modal.added.title": "ਫਿਲਟਰ ਨੂੰ ਜੋੜਿਆ!",
  "filter_modal.select_filter.expired": "ਮਿਆਦ ਪੁੱਗੀ",
  "filter_modal.select_filter.prompt_new": "ਨਵੀਂ ਕੈਟਾਗਰੀ: {name}",
  "filter_modal.select_filter.search": "ਖੋਜੋ ਜਾਂ ਬਣਾਓ",
  "filter_modal.select_filter.title": "ਇਸ ਪੋਸਟ ਨੂੰ ਫਿਲਟਰ ਕਰੋ",
  "filter_modal.title.status": "ਇੱਕ ਪੋਸਟ ਨੂੰ ਫਿਲਟਰ ਕਰੋ",
  "filtered_notifications_banner.title": "ਫਿਲਟਰ ਕੀਤੇ ਨੋਟੀਫਿਕੇਸ਼ਨ",
  "firehose.all": "ਸਭ",
  "firehose.local": "ਇਹ ਸਰਵਰ",
  "firehose.remote": "ਹੋਰ ਸਰਵਰ",
  "follow_request.authorize": "ਪਰਮਾਣਿਤ",
  "follow_request.reject": "ਰੱਦ ਕਰੋ",
  "follow_suggestions.dismiss": "ਮੁੜ ਨਾ ਵੇਖਾਓ",
  "follow_suggestions.personalized_suggestion": "ਨਿੱਜੀ ਸੁਝਾਅ",
  "follow_suggestions.popular_suggestion": "ਹਰਮਨਪਿਆਰੇ ਸੁਝਾਅ",
  "follow_suggestions.popular_suggestion_longer": "{domain} ਉੱਤੇ ਹਰਮਨਪਿਆਰੇ",
  "follow_suggestions.view_all": "ਸਭ ਵੇਖੋ",
  "follow_suggestions.who_to_follow": "ਕਿਸ ਨੂੰ ਫ਼ਾਲੋ ਕਰੀਏ",
  "followed_tags": "ਫ਼ਾਲੋ ਕੀਤੇ ਹੈਸ਼ਟੈਗ",
  "footer.about": "ਸਾਡੇ ਬਾਰੇ",
  "footer.about_mastodon": "Mastodon ਬਾਰੇ",
  "footer.about_server": "{domain} ਬਾਰੇ",
  "footer.about_this_server": "ਇਸ ਬਾਰੇ",
  "footer.directory": "ਪਰੋਫਾਇਲ ਡਾਇਰੈਕਟਰੀ",
  "footer.get_app": "ਐਪ ਲਵੋ",
  "footer.keyboard_shortcuts": "ਕੀਬੋਰਡ ਸ਼ਾਰਟਕੱਟ",
  "footer.privacy_policy": "ਪਰਦੇਦਾਰੀ ਨੀਤੀ",
  "footer.source_code": "ਸਰੋਤ ਕੋਡ ਵੇਖੋ",
  "footer.status": "ਹਾਲਤ",
  "footer.terms_of_service": "ਸੇਵਾ ਦੀਆਂ ਸ਼ਰਤਾਂ",
  "form_field.optional": "(ਚੋਣਵਾਂ)",
  "generic.saved": "ਸਾਂਭੀ ਗਈ",
  "getting_started.heading": "ਸ਼ੁਰੂ ਕਰੀਏ",
  "hashtag.browse": "#{hashtag} ਵਿੱਚ ਪੋਸਟਾਂ ਨੂੰ ਵੇਖੋ",
  "hashtag.column_header.tag_mode.all": "ਅਤੇ {additional}",
  "hashtag.column_header.tag_mode.any": "ਜਾਂ {additional}",
  "hashtag.column_header.tag_mode.none": "{additional} ਬਿਨਾਂ",
  "hashtag.column_settings.select.no_options_message": "ਕੋਈ ਸੁਝਾਅ ਨਹੀਂ ਲੱਭਾ",
  "hashtag.column_settings.select.placeholder": "ਹੈਸ਼ਟੈਗ ਦਿਓ…",
  "hashtag.column_settings.tag_mode.all": "ਇਹ ਸਭ",
  "hashtag.column_settings.tag_mode.any": "ਇਹਨਾਂ ਵਿੱਚੋਂ ਕੋਈ",
  "hashtag.column_settings.tag_mode.none": "ਇਹਨਾਂ ਵਿੱਚੋਂ ਕੋਈ ਨਹੀਂ",
  "hashtag.column_settings.tag_toggle": "Include additional tags in this column",
  "hashtag.counter_by_accounts": "{count, plural, one {{counter} ਹਿੱਸੇਦਾਰ} other {{counter} ਹਿੱਸੇਦਾਰ}}",
  "hashtag.feature": "ਪਰੋਫਾਇਲ ਉੱਤੇ ਫ਼ੀਚਰ",
  "hashtag.follow": "ਹੈਸ਼ਟੈਗ ਨੂੰ ਫ਼ਾਲੋ ਕਰੋ",
  "hashtag.mute": "#{hashtag} ਨੂੰ ਮੌਨ ਕਰੋ",
  "hashtag.unfeature": "ਪਰੋਫਾਇਲ ਉੱਤੇ ਫ਼ੀਚਰ ਨਾ ਕਰੋ",
  "hashtag.unfollow": "ਹੈਸ਼ਟੈਗ ਨੂੰ ਅਣ-ਫ਼ਾਲੋ ਕਰੋ",
  "hashtags.and_other": "…ਅਤੇ {count, plural, one {}other {# ਹੋਰ}}",
  "hints.profiles.see_more_followers": "{domain} ਉੱਤੇ ਹੋਰ ਫ਼ਾਲੋਅਰ ਵੇਖੋ",
  "hints.profiles.see_more_follows": "{domain} ਉੱਤੇ ਹੋਰ ਫ਼ਾਲੋ ਨੂੰ ਵੇਖੋ",
  "hints.profiles.see_more_posts": "{domain} ਉੱਤੇ ਹੋਰ ਪੋਸਟਾਂ ਨੂੰ ਵੇਖੋ",
  "home.column_settings.show_reblogs": "ਬੂਸਟਾਂ ਨੂੰ ਵੇਖੋ",
  "home.column_settings.show_replies": "ਜਵਾਬਾਂ ਨੂੰ ਵੇਖੋ",
  "home.hide_announcements": "ਐਲਾਨਾਂ ਨੂੰ ਓਹਲੇ ਕਰੋ",
  "home.pending_critical_update.link": "ਅੱਪਡੇਟ ਵੇਖੋ",
  "home.pending_critical_update.title": "ਗੰਭੀਰ ਸੁਰੱਖਿਆ ਅੱਪਡੇਟ ਮੌਜੂਦ ਹੈ!",
  "home.show_announcements": "ਐਲਾਨਾਂ ਨੂੰ ਵੇਖਾਓ",
  "ignore_notifications_modal.ignore": "ਨੋਟਫਿਕੇਸ਼ਨਾਂ ਨੂੰ ਅਣਡਿੱਠਾ ਕਰੋ",
  "info_button.label": "ਮਦਦ",
  "interaction_modal.go": "ਜਾਓ",
  "interaction_modal.no_account_yet": "ਹਾਲੇ ਖਾਤਾ ਨਹੀਂ ਹੈ?",
  "interaction_modal.on_another_server": "ਵੱਖਰੇ ਸਰਵਰ ਉੱਤੇ",
  "interaction_modal.on_this_server": "ਇਸ ਸਰਵਰ ਉੱਤੇ",
  "interaction_modal.title": "ਜਾਰੀ ਰੱਖਣ ਲਈ ਸਾਈਨ ਇਨ ਕਰੋ",
  "interaction_modal.username_prompt": "ਜਿਵੇਂ {example}",
  "intervals.full.days": "{number, plural, one {# ਦਿਨ} other {# ਦਿਨ}}",
  "intervals.full.hours": "{number, plural, one {# ਘੰਟਾ} other {# ਘੰਟੇ}}",
  "intervals.full.minutes": "{number, plural, one {# ਮਿੰਟ} other {# ਮਿੰਟ}}",
  "keyboard_shortcuts.back": "ਪਿੱਛੇ ਜਾਓ",
  "keyboard_shortcuts.blocked": "ਪਾਬੰਦੀ ਲਾਏ ਵਰਤੋਂਕਾਰਾਂ ਦੀ ਸੂਚੀ ਖੋਲ੍ਹੋ",
  "keyboard_shortcuts.boost": "ਪੋਸਟ ਨੂੰ ਬੂਸਟ ਕਰੋ",
  "keyboard_shortcuts.column": "ਫੋਕਸ ਕਾਲਮ",
  "keyboard_shortcuts.compose": "to focus the compose textarea",
  "keyboard_shortcuts.description": "ਵਰਣਨ",
  "keyboard_shortcuts.down": "ਸੂਚੀ ਵਿੱਚ ਹੇਠਾਂ ਭੇਜੋ",
  "keyboard_shortcuts.enter": "ਪੋਸਟ ਨੂੰ ਖੋਲ੍ਹੋ",
  "keyboard_shortcuts.favourite": "ਪੋਸਟ ਨੂੰ ਪਸੰਦ ਕਰੋ",
  "keyboard_shortcuts.favourites": "ਮਨਪਸੰਦ ਸੂਚੀ ਨੂੰ ਖੋਲ੍ਹੋ",
  "keyboard_shortcuts.federated": "",
  "keyboard_shortcuts.heading": "ਕੀਬੋਰਡ ਸ਼ਾਰਟਕੱਟ",
  "keyboard_shortcuts.home": "ਮੁੱਖ-ਸਫ਼ਾ ਟਾਈਮ-ਲਾਈਨ ਨੂੰ ਖੋਲ੍ਹੋ",
  "keyboard_shortcuts.legend": "ਇਸ ਸੰਕੇਤ ਨੂੰ ਵੇਖਾਓ",
  "keyboard_shortcuts.local": "ਲੋਕਲ ਸਮਾਂ-ਲਾਈਨ ਨੂੰ ਖੋਲ੍ਹੋ",
  "keyboard_shortcuts.mention": "ਲੇਖਕ ਦਾ ਜ਼ਿਕਰ",
  "keyboard_shortcuts.muted": "ਮੌਨ ਕੀਤੇ ਵਰਤੋਂਕਾਰ ਦੀ ਸੂਚੀ ਨੂੰ ਖੋਲ੍ਹੋ",
  "keyboard_shortcuts.my_profile": "ਆਪਣੇ ਪਰੋਫਾਈਲ ਨੂੰ ਖੋਲ੍ਹੋ",
  "keyboard_shortcuts.notifications": "ਨੋਟੀਫਿਕੇਸ਼ਨ ਕਾਲਮ ਖੋਲ੍ਹੋ",
  "keyboard_shortcuts.open_media": "ਮੀਡੀਏ ਨੂੰ ਖੋਲ੍ਹੋ",
  "keyboard_shortcuts.pinned": "ਪਿੰਨ ਕੀਤੀਆਂ ਪੋਸਟਾਂ ਦੀ ਸੂਚੀ ਨੂੰ ਖੋਲ੍ਹੋ",
  "keyboard_shortcuts.profile": "ਲੇਖਕ ਦਾ ਪਰੋਫਾਈਲ ਖੋਲ੍ਹੋ",
  "keyboard_shortcuts.reply": "ਪੋਸਟ ਨੂੰ ਜਵਾਬ ਦਿਓ",
  "keyboard_shortcuts.requests": "ਫ਼ਾਲੋ ਦੀਆਂ ਬੇਨਤੀਆਂ ਦੀ ਸੂਚੀ ਨੂੰ ਖੋਲ੍ਹੋ",
  "keyboard_shortcuts.search": "ਖੋਜ ਪੱਟੀ ਨੂੰ ਫੋਕਸ ਕਰੋ",
  "keyboard_shortcuts.spoilers": "CW ਖੇਤਰ ਨੂੰ ਵੇਖਾਓ/ਓਹਲੇ ਕਰੋ",
  "keyboard_shortcuts.start": "to open \"get started\" column",
  "keyboard_shortcuts.toggle_hidden": "to show/hide text behind CW",
  "keyboard_shortcuts.toggle_sensitivity": "ਮੀਡੀਆ ਦਿਖਾਉਣ/ਲੁਕਾਉਣ ਲਈ",
  "keyboard_shortcuts.toot": "ਨਵੀਂ ਪੋਸਟ ਸ਼ੁਰੂ ਕਰੋ",
  "keyboard_shortcuts.translate": "ਪੋਸਟ ਨੂੰ ਅਨੁਵਾਦ ਕਰਨ ਲਈ",
  "keyboard_shortcuts.unfocus": "to un-focus compose textarea/search",
  "keyboard_shortcuts.up": "ਸੂਚੀ ਵਿੱਚ ਉੱਤੇ ਭੇਜੋ",
  "learn_more_link.got_it": "ਸਮਝ ਗਏ",
  "learn_more_link.learn_more": "ਹੋਰ ਜਾਣੋ",
  "lightbox.close": "ਬੰਦ ਕਰੋ",
  "lightbox.next": "ਅਗਲੀ",
  "lightbox.previous": "ਪਿਛਲੀ",
  "limited_account_hint.action": "ਪਰੋਫਾਈਲ ਨੂੰ ਕਿਵੇਂ ਵੀ ਵੇਖਾਓ",
  "link_preview.author": "{name} ਵਲੋਂ",
  "link_preview.more_from_author": "{name} ਵਲੋਂ ਹੋਰ",
  "link_preview.shares": "{count, plural, one {{counter} ਪੋਸਟ} other {{counter} ਪੋਸਟਾਂ}}",
  "lists.add_member": "ਜੋੜੋ",
  "lists.add_to_list": "ਸੂਚੀ ਵਿੱਚ ਜੋੜੋ",
  "lists.create": "ਬਣਾਓ",
  "lists.create_list": "ਸੂਚੀ ਬਣਾਓ",
  "lists.delete": "ਸੂਚੀ ਹਟਾਓ",
  "lists.done": "ਮੁਕੰਮਲ",
  "lists.edit": "ਸੂਚੀ ਨੂੰ ਸੋਧੋ",
  "lists.find_users_to_add": "ਜੋੜਨ ਲਈ ਵਰਤੋਂਕਾਰ ਲੱਭੋ",
  "lists.list_members_count": "{count, plural, one {# ਮੈਂਬਰ} other {# ਮੈਂਬਰ}}",
  "lists.list_name": "ਸੂਚੀ ਦਾ ਨਾਂ",
  "lists.new_list_name": "ਨਵੀਂ ਸੂਚੀਂ ਦਾ ਨਾਂ",
  "lists.no_lists_yet": "ਹਾਲੇ ਕੋਈ ਵੀ ਸੂਚੀ ਨਹੀਂ ਹੈ।",
  "lists.no_members_yet": "ਹਾਲੇ ਮੈਂਬਰ ਨਹੀਂ ਹਨ।",
  "lists.no_results_found": "ਕੋਈ ਨਤੀਜਾ ਨਹੀਂ ਮਿਲਿਆ।",
  "lists.remove_member": "ਹਟਾਓ",
  "lists.replies_policy.followed": "ਕੋਈ ਵੀ ਫ਼ਾਲੋ ਕੀਤਾ ਵਰਤੋਂਕਾਰ",
  "lists.replies_policy.list": "ਸੂਚੀ ਦੇ ਮੈਂਬਰ",
  "lists.replies_policy.none": "ਕੋਈ ਨਹੀਂ",
  "lists.save": "ਸੰਭਾਲੋ",
  "lists.search": "ਖੋਜੋ",
  "loading_indicator.label": "ਲੋਡ ਹੋ ਰਿਹਾ ਹੈ…",
  "media_gallery.hide": "ਲੁਕਾਓ",
  "mute_modal.hide_from_notifications": "ਨੋਟੀਫਿਕੇਸ਼ਨਾਂ ਵਿੱਚੋਂ ਲੁਕਾਓ",
  "mute_modal.hide_options": "ਚੋਣਾਂ ਨੂੰ ਲੁਕਾਓ",
  "mute_modal.show_options": "ਚੋਣਾਂ ਨੂੰ ਵੇਖਾਓ",
  "mute_modal.title": "ਵਰਤੋਂਕਾਰ ਨੂੰ ਮੌਨ ਕਰਨਾ ਹੈ?",
  "navigation_bar.about": "ਇਸ ਬਾਰੇ",
  "navigation_bar.account_settings": "ਪਾਸਵਰਡ ਅਤੇ ਸੁਰੱਖਿਆ",
  "navigation_bar.administration": "ਪਰਸ਼ਾਸ਼ਨ",
  "navigation_bar.advanced_interface": "ਤਕਨੀਕੀ ਵੈੱਬ ਇੰਟਰਫੇਸ ਵਿੱਚ ਖੋਲ੍ਹੋ",
  "navigation_bar.automated_deletion": "ਆਪਣੇ-ਆਪ ਹਟਾਈ ਪੋਸਟ",
  "navigation_bar.blocks": "ਪਾਬੰਦੀ ਲਾਏ ਵਰਤੋਂਕਾਰ",
  "navigation_bar.bookmarks": "ਬੁੱਕਮਾਰਕ",
  "navigation_bar.direct": "ਨਿੱਜੀ ਜ਼ਿਕਰ",
  "navigation_bar.domain_blocks": "ਪਾਬੰਦੀ ਲਾਏ ਡੋਮੇਨ",
  "navigation_bar.favourites": "ਮਨਪਸੰਦ",
  "navigation_bar.filters": "ਮੌਨ ਕੀਤੇ ਸ਼ਬਦ",
  "navigation_bar.follow_requests": "ਫ਼ਾਲੋ ਦੀਆਂ ਬੇਨਤੀਆਂ",
  "navigation_bar.followed_tags": "ਫ਼ਾਲੋ ਕੀਤੇ ਹੈਸ਼ਟੈਗ",
  "navigation_bar.follows_and_followers": "ਫ਼ਾਲੋ ਅਤੇ ਫ਼ਾਲੋ ਕਰਨ ਵਾਲੇ",
  "navigation_bar.lists": "ਸੂਚੀਆਂ",
  "navigation_bar.live_feed_local": "ਲਾਈਵ ਫੀਡ (ਲੋਕਲ)",
  "navigation_bar.live_feed_public": "ਲਾਈਵ ਫੀਡ (ਪਬਲਿਕ)",
  "navigation_bar.logout": "ਲਾਗ ਆਉਟ",
  "navigation_bar.more": "ਹੋਰ",
  "navigation_bar.mutes": "ਮੌਨ ਕੀਤੇ ਵਰਤੋਂਕਾਰ",
  "navigation_bar.preferences": "ਪਸੰਦਾਂ",
  "navigation_bar.privacy_and_reach": "ਪਰਦੇਦਾਰੀ ਅਤੇ ਪਹੁੰਚ",
  "navigation_bar.search": "ਖੋਜੋ",
  "navigation_bar.search_trends": "ਖੋਜ / ਰੁਝਾਨ",
  "not_signed_in_indicator.not_signed_in": "ਇਹ ਸਰੋਤ ਵਰਤਣ ਲਈ ਤੁਹਾਨੂੰ ਲਾਗਇਨ ਕਰਨ ਦੀ ਲੋੜ ਹੈ।",
  "notification.admin.sign_up": "{name} ਨੇ ਸਾਈਨ ਅੱਪ ਕੀਤਾ",
  "notification.annual_report.view": "#Wrapstodon ਨੂੰ ਵੇਖੋ",
  "notification.favourite": "{name} ਨੇ ਤੁਹਾਡੀ ਪੋਸਟ ਨੂੰ ਪਸੰਦ ਕੀਤਾ",
  "notification.favourite_pm": "{name} ਨੇ ਤੁਹਾਡੇ ਨਿੱਜੀ ਜ਼ਿਕਰ ਨੂੰ ਪਸੰਦ ਕੀਤਾ",
  "notification.follow": "{name} ਨੇ ਤੁਹਾਨੂੰ ਫ਼ਾਲੋ ਕੀਤਾ",
  "notification.follow.name_and_others": "{name} ਅਤੇ <a>{count, plural, one {# ਹੋਰ} other {# ਹੋਰਾਂ}}</a> ਨੇ ਤੁਹਾਨੂੰ ਫ਼ਾਲੋ ਕੀਤਾ",
  "notification.follow_request": "{name} ਨੇ ਤੁਹਾਨੂੰ ਫ਼ਾਲੋ ਕਰਨ ਦੀ ਬੇਨਤੀ ਕੀਤੀ ਹੈ",
  "notification.label.mention": "ਜ਼ਿਕਰ",
  "notification.label.private_mention": "ਨਿੱਜੀ ਜ਼ਿਕਰ",
  "notification.label.private_reply": "ਪ੍ਰਾਈਵੇਟ ਜਵਾਬ",
  "notification.label.reply": "ਜਵਾਬ",
  "notification.mention": "ਜ਼ਿਕਰ",
  "notification.mentioned_you": "{name} ਨੇ ਤੁਹਾਡਾ ਜ਼ਿਕਰ ਕੀਤਾ",
  "notification.moderation-warning.learn_more": "ਹੋਰ ਜਾਣੋ",
  "notification.moderation_warning.action_disable": "ਤੁਹਾਡੇ ਖਾਤੇ ਨੂੰਅਸਮਰੱਥ ਕੀਤਾ ਹੈ।",
  "notification.moderation_warning.action_silence": "ਤੁਹਾਡੇ ਖਾਤੇ ਨੂੰ ਸੀਮਿਤ ਕੀਤਾ ਗਿਆ ਹੈ।",
  "notification.moderation_warning.action_suspend": "ਤੁਹਾਡੇ ਖਾਤੇ ਨੂੰ ਮੁਅੱਤਲ ਕੀਤਾ ਗਿਆ ਹੈ।",
  "notification.reblog": "{name} boosted your status",
  "notification.relationships_severance_event": "{name} ਨਾਲ ਕਨੈਕਸ਼ਨ ਗੁਆਚੇ",
  "notification.relationships_severance_event.learn_more": "ਹੋਰ ਜਾਣੋ",
  "notification.status": "{name} ਨੇ ਹੁਣੇ ਪੋਸਟ ਕੀਤਾ",
  "notification.update": "{name} ਨੋ ਪੋਸਟ ਨੂੰ ਸੋਧਿਆ",
  "notification_requests.accept": "ਮਨਜ਼ੂਰ",
  "notification_requests.confirm_accept_multiple.title": "ਨੋਟੀਫਿਕੇਸ਼ਨ ਬੇਨਤੀਆਂ ਨੂੰ ਮਨਜ਼ੂਰ ਕਰਨਾ ਹੈ?",
  "notification_requests.confirm_dismiss_multiple.title": "ਨੋਟੀਫਿਕੇਸ਼ਨ ਬੇਨਤੀਆਂ ਨੂੰ ਖ਼ਾਰਜ ਕਰਨਾ ਹੈ?",
  "notification_requests.dismiss": "ਖ਼ਾਰਜ ਕਰੋ",
  "notification_requests.edit_selection": "ਸੋਧੋ",
  "notification_requests.exit_selection": "ਮੁਕੰਮਲ",
  "notification_requests.notifications_from": "{name} ਵਲੋਂ ਨੋਟੀਫਿਕੇਸ਼ਨ",
  "notification_requests.title": "ਫਿਲਟਰ ਕੀਤੇ ਨੋਟੀਫਿਕੇਸ਼ਨ",
  "notification_requests.view": "ਨੋਟਫਿਕੇਸ਼ਨਾਂ ਨੂੰ ਵੇਖੋ",
  "notifications.clear": "ਸੂਚਨਾਵਾਂ ਨੂੰ ਮਿਟਾਓ",
  "notifications.clear_confirmation": "ਕੀ ਤੁਸੀਂ ਆਪਣੇ ਸਾਰੇ ਨੋਟੀਫਿਕੇਸ਼ਨਾਂ ਨੂੰ ਪੱਕੇ ਤੌਰ ਉੱਤੇ ਹਟਾਉਣਾ ਚਾਹੁੰਦੇ ਹੋ?",
  "notifications.clear_title": "ਨੋਟਫਿਕੇਸ਼ਨਾਂ ਨੂੰ ਮਿਟਾਉਣਾ ਹੈ?",
  "notifications.column_settings.admin.report": "ਨਵੀਆਂ ਰਿਪੋਰਟਾਂ:",
  "notifications.column_settings.alert": "ਡੈਸਕਟਾਪ ਸੂਚਨਾਵਾਂ",
  "notifications.column_settings.favourite": "ਮਨਪਸੰਦ:",
  "notifications.column_settings.filter_bar.advanced": "ਸਭ ਵਰਗਾਂ ਨੂੰ ਵੇਖਾਓ",
  "notifications.column_settings.filter_bar.category": "ਫੌਰੀ ਫਿਲਟਰ ਪੱਟੀ",
  "notifications.column_settings.follow": "ਨਵੇਂ ਫ਼ਾਲੋਅਰ:",
  "notifications.column_settings.follow_request": "ਨਵੀਆਂ ਫ਼ਾਲੋ ਬੇਨਤੀਆਂ:",
  "notifications.column_settings.group": "ਗਰੁੱਪ",
  "notifications.column_settings.mention": "ਜ਼ਿਕਰ:",
  "notifications.column_settings.poll": "ਪੋਲ ਦੇ ਨਤੀਜੇ:",
  "notifications.column_settings.push": "ਪੁਸ਼ ਨੋਟੀਫਿਕੇਸ਼ਨ",
  "notifications.column_settings.quote": "ਹਵਾਲੇ:",
  "notifications.column_settings.reblog": "ਬੂਸਟ:",
  "notifications.column_settings.show": "ਕਾਲਮ ਵਿੱਚ ਵੇਖਾਓ",
  "notifications.column_settings.sound": "ਆਵਾਜ਼ ਚਲਾਓ",
  "notifications.column_settings.status": "ਨਵੀਆਂ ਪੋਸਟਾਂ:",
  "notifications.column_settings.unread_notifications.category": "ਨਾ-ਪੜ੍ਹੇ ਨੋਟੀਫਿਕੇਸ਼ਨ",
  "notifications.column_settings.unread_notifications.highlight": "ਨਾ-ਪੜ੍ਹੇ ਨੋਟੀਫਿਕੇਸ਼ਨਾਂ ਨੂੰ ਉਘਾੜੋ",
  "notifications.column_settings.update": "ਸੋਧ:",
  "notifications.filter.all": "ਸਭ",
  "notifications.filter.boosts": "ਬੂਸਟ",
  "notifications.filter.favourites": "ਮਨਪਸੰਦ",
  "notifications.filter.follows": "ਫ਼ਾਲੋ",
  "notifications.filter.mentions": "ਜ਼ਿਕਰ",
  "notifications.filter.polls": "ਪੋਲ ਦੇ ਨਤੀਜੇ",
  "notifications.filter.statuses": "ਤੁਹਾਡੇ ਵਲੋਂ ਫ਼ਾਲੋ ਕੀਤੇ ਲੋਕਾਂ ਤੋਂ ਅੱਪਡੇਟ",
  "notifications.grant_permission": "ਇਜਾਜ਼ਤ ਦਿਓ।",
  "notifications.group": "{count} ਨੋਟੀਫਿਕੇਸ਼ਨ",
  "notifications.mark_as_read": "ਹਰ ਨੋਟੀਫਿਕੇਸ਼ਨ ਨੂੰ ਪੜ੍ਹੇ ਵਜੋਂ ਨਿਸ਼ਾਨੀ ਲਾਓ",
  "notifications.policy.accept": "ਮਨਜ਼ੂਰ",
  "notifications.policy.accept_hint": "ਨੋਟੀਫਿਕੇਸ਼ਨਾਂ ਵਿੱਚ ਵੇਖਾਓ",
  "notifications.policy.drop": "ਅਣਡਿੱਠਾ",
  "notifications.policy.filter": "ਫਿਲਟਰ",
  "notifications.policy.filter_new_accounts_title": "ਨਵੇਂ ਖਾਤੇ",
  "notifications.policy.filter_not_followers_title": "ਲੋਕ ਤੁਹਾਨੂੰ ਫ਼ਾਲੋ ਨਹੀਂ ਕਰਦੇ",
  "notifications.policy.filter_not_following_hint": "ਜਦ ਤੱਕ ਤੁਸੀਂ ਉਹਨਾਂ ਨੂੰ ਖੁਦ ਮਨਜ਼ੂਰੀ ਨਹੀਂ ਦਿੰਦੇ",
  "notifications_permission_banner.enable": "ਡੈਸਕਟਾਪ ਸੂਚਨਾਵਾਂ ਸਮਰੱਥ ਕਰੋ",
  "onboarding.follows.back": "ਪਿੱਛੇ",
  "onboarding.follows.search": "ਖੋਜੋ",
  "onboarding.profile.display_name": "ਦਿਖਾਇਆ ਜਾਣ ਵਾਲਾ ਨਾਂ",
  "onboarding.profile.note": "ਜਾਣਕਾਰੀ",
  "onboarding.profile.title": "ਪਰੋਫਾਈਲ ਸੈਟਅੱਪ",
  "onboarding.profile.upload_avatar": "ਪਰੋਫਾਈਲ ਤਸਵੀਰ ਅੱਪਲੋਡ ਕਰੋ",
  "poll.closed": "ਬੰਦ ਹੈ",
  "poll.refresh": "ਤਾਜ਼ਾ ਕਰੋ",
  "poll.reveal": "ਨਤੀਜਿਆਂ ਨੂੰ ਵੇਖੋ",
  "poll.vote": "ਵੋਟ ਪਾਓ",
  "poll.voted": "ਤੁਸੀਂ ਇਸ ਜਵਾਬ ਲਈ ਵੋਟ ਕੀਤਾ",
  "privacy.change": "ਪੋਸਟ ਦੀ ਪਰਦੇਦਾਰੀ ਨੂੰ ਬਦਲੋ",
  "privacy.direct.long": "ਪੋਸਟ ਵਿੱਚ ਜ਼ਿਕਰ ਕੀਤੇ ਹਰ ਕੋਈ",
  "privacy.direct.short": "ਨਿੱਜੀ ਜ਼ਿਕਰ",
  "privacy.private.long": "ਸਿਰਫ਼ ਤੁਹਾਡੇ ਫ਼ਾਲੋਅਰ ਹੀ",
  "privacy.private.short": "ਫ਼ਾਲੋਅਰ",
  "privacy.public.short": "ਜਨਤਕ",
  "privacy_policy.last_updated": "ਆਖਰੀ ਵਾਰ {date} ਨੂੰ ਅੱਪਡੇਟ ਕੀਤਾ",
  "privacy_policy.title": "ਪਰਦੇਦਾਰੀ ਨੀਤੀ",
  "recommended": "ਸਿਫ਼ਾਰਸ਼ੀ",
  "refresh": "ਤਾਜ਼ਾ ਕਰੋ",
  "regeneration_indicator.please_stand_by": "ਕਿਰਪਾ ਕਰਕੇ ਉਡੀਕੋ।",
  "relative_time.days": "{number}ਦਿਨ",
  "relative_time.full.days": "{number, plural, one {# ਦਿਨ} other {# ਦਿਨ}} ਪਹਿਲਾਂ",
  "relative_time.full.hours": "{number, plural, one {# ਘੰਟਾ} other {# ਘੰਟੇ}} ਪਹਿਲਾਂ",
  "relative_time.full.just_now": "ਹੁਣੇ ਹੀ",
  "relative_time.full.minutes": "{number, plural, one {# ਮਿੰਟ} other {# ਮਿੰਟ}} ਪਹਿਲਾਂ",
  "relative_time.full.seconds": "{number, plural, one {# ਸਕਿੰਟ} other {# ਸਕਿੰਟ}} ਪਹਿਲਾਂ",
  "relative_time.hours": "{number}ਘੰ",
  "relative_time.just_now": "ਹੁਣੇ",
  "relative_time.minutes": "{number}ਮਿੰ",
  "relative_time.seconds": "{number}ਸ",
  "relative_time.today": "ਅੱਜ",
  "remove_quote_hint.button_label": "ਸਮਝ ਗਏ",
  "reply_indicator.cancel": "ਰੱਦ ਕਰੋ",
  "reply_indicator.poll": "ਵੋਟਾਂ",
  "report.block": "ਬਲਾਕ",
  "report.categories.legal": "ਕਨੂੰਨੀ",
  "report.categories.other": "ਬਾਕੀ",
  "report.categories.spam": "ਸਪੈਮ",
  "report.category.title_account": "ਪਰੋਫਾਈਲ",
  "report.category.title_status": "ਪੋਸਟ",
  "report.close": "ਮੁਕੰਮਲ",
  "report.forward": "{target} ਨੂੰ ਅੱਗੇ ਭੇਜੋ",
  "report.mute": "ਮੌਨ ਕਰੋ",
  "report.next": "ਅਗਲੀ",
  "report.placeholder": "ਵਧੀਕ ਟਿੱਪਣੀਆਂ",
  "report.reasons.dislike": "ਮੈਨੂੰ ਇਹ ਪਸੰਦ ਨਹੀਂ ਹੈ",
  "report.reasons.legal": "ਇਹ ਗ਼ੈਰ-ਕਨੂੰਨੀ ਹੈ",
  "report.reasons.other": "ਇਹ ਕੁਝ ਹੋਰ ਹੈ",
  "report.reasons.spam": "ਇਹ ਸਪੈਮ ਹੈ",
  "report.rules.subtitle": "ਲਾਗੂ ਹੋਣ ਵਾਲੇ ਸਾਰੇ ਚੁਣੋ",
  "report.rules.title": "ਕਿਹੜੇ ਨਿਯਮਾਂ ਦਾ ਉਲੰਘਣ ਕੀਤਾ ਜਾ ਰਿਹਾ ਹੈ?",
  "report.statuses.subtitle": "ਲਾਗੂ ਹੋਣ ਵਾਲੇ ਸਾਰੇ ਚੁਣੋ",
  "report.submit": "ਭੇਜੋ",
  "report.target": "{target} ਰਿਪੋਰਟ",
  "report.thanks.title": "ਇਸ ਨੂੰ ਵੇਖਣਾ ਨਹੀਂ ਚਾਹੁੰਦੇ ਹੋ?",
  "report.thanks.title_actionable": "ਰਿਪੋਰਟ ਕਰਨ ਲਈ ਧੰਨਵਾਦ ਹੈ। ਅਸੀਂ ਇਸ ਦੀ ਛਾਣਬੀਣ ਕਰਾਂਗੇ।",
  "report.unfollow": "@{name} ਨੂੰ ਅਣ-ਫ਼ਾਲੋ ਕਰੋ",
  "report_notification.attached_statuses": "{count, plural, one {# post} other {# posts}} attached",
  "report_notification.categories.legal": "ਕਨੂੰਨੀ",
  "report_notification.categories.legal_sentence": "ਗ਼ੈਰ-ਕਨੂੰਨੀ ਸਮੱਗਰੀ",
  "report_notification.categories.other": "ਬਾਕੀ",
  "report_notification.categories.other_sentence": "ਹੋਰ",
  "report_notification.categories.spam": "ਸਪੈਮ",
  "report_notification.categories.spam_sentence": "ਸਪੈਮ",
  "report_notification.categories.violation": "ਨਿਯਮ ਦੀ ਉਲੰਘਣਾ",
  "report_notification.categories.violation_sentence": "ਨਿਯਮ ਦੀ ਉਲੰਘਣਾ",
  "report_notification.open": "ਰਿਪੋਰਟ ਨੂੰ ਖੋਲ੍ਹੋ",
  "search.clear": "ਖੋਜ ਨੂੰ ਸਾਫ਼ ਕਰੋ",
  "search.no_recent_searches": "ਕੋਈ ਸੱਜਰੀ ਖੋਜ ਨਹੀਂ ਹੈ",
  "search.placeholder": "ਖੋਜੋ",
  "search.quick_action.go_to_account": "ਪਰੋਫਾਈਲ {x} ਉੱਤੇ ਜਾਓ",
  "search.quick_action.go_to_hashtag": "ਹੈਸ਼ਟੈਗ {x} ਉੱਤੇ ਜਾਓ",
  "search_popout.language_code": "ISO ਭਾਸ਼ਾ ਕੋਡ",
  "search_popout.options": "ਖੋਜ ਲਈ ਚੋਣਾਂ",
  "search_popout.quick_actions": "ਫੌਰੀ ਕਾਰਵਾਈਆਂ",
  "search_popout.recent": "ਸੱਜਰੀਆਂ ਖੋਜੋ",
  "search_popout.specific_date": "ਖਾਸ ਤਾਰੀਖ",
  "search_popout.user": "ਵਰਤੋਂਕਾਰ",
  "search_results.accounts": "ਪਰੋਫਾਈਲ",
  "search_results.all": "ਸਭ",
  "search_results.hashtags": "ਹੈਸ਼ਟੈਗ",
  "search_results.no_results": "ਕੋਈ ਨਤੀਜੇ ਨਹੀਂ ਹਨ।",
  "search_results.see_all": "ਸਭ ਵੇਖੋ",
  "search_results.statuses": "ਪੋਸਟਾਂ",
  "search_results.title": "\"{q}\" ਨੂੰ ਖੋਜੋ",
  "server_banner.active_users": "ਸਰਗਰਮ ਵਰਤੋਂਕਾਰ",
  "sign_in_banner.create_account": "ਖਾਤਾ ਬਣਾਓ",
  "sign_in_banner.sign_in": "ਲਾਗਇਨ",
  "sign_in_banner.sso_redirect": "ਲਾਗਇਨ ਜਾਂ ਰਜਿਸਟਰ ਕਰੋ",
  "status.admin_status": "",
  "status.block": "@{name} ਉੱਤੇ ਪਾਬੰਦੀ ਲਾਓ",
  "status.bookmark": "ਬੁੱਕਮਾਰਕ",
  "status.context.retry": "ਮੁੜ-ਕੋਸ਼ਿਸ਼",
  "status.context.show": "ਵੇਖਾਓ",
  "status.copy": "ਪੋਸਟ ਲਈ ਲਿੰਕ ਕਾਪੀ ਕਰੋ",
  "status.delete": "ਹਟਾਓ",
  "status.delete.success": "ਪੋਸਟ ਨੂੰ ਹਟਾਇਆ",
  "status.direct": "{name} ਪ੍ਰਾਈਵੇਟ ਜ਼ਿਕਰ",
  "status.direct_indicator": "ਪ੍ਰਾਈਵੇਟ ਜ਼ਿਕਰ",
  "status.edit": "ਸੋਧ",
  "status.edited": "ਆਖਰੀ ਸੋਧ ਦੀ ਤਾਰੀਖ {date}",
  "status.edited_x_times": "Edited {count, plural, one {# time} other {# times}}",
  "status.favourite": "ਪਸੰਦ",
  "status.filter": "ਇਸ ਪੋਸਟ ਨੂੰ ਫਿਲਟਰ ਕਰੋ",
  "status.history.created": "{name} ਨੇ {date} ਨੂੰ ਬਣਾਇਆ",
  "status.history.edited": "{name} ਨੇ {date} ਨੂੰ ਸੋਧਿਆ",
  "status.load_more": "ਹੋਰ ਦਿਖਾਓ",
  "status.media.open": "ਖੋਲ੍ਹਣ ਲਈ ਕਲਿੱਕ ਕਰੋ",
  "status.media.show": "ਵੇਖਾਉਣ ਲਈ ਕਲਿੱਕ ਕਰੋ",
  "status.media_hidden": "ਮੀਡਿਆ ਲੁਕਵਾਂ ਹੈ",
  "status.mention": "@{name} ਦਾ ਜ਼ਿਕਰ",
  "status.more": "ਹੋਰ",
  "status.mute": "@{name} ਨੂੰ ਮੌਨ ਕਰੋ",
  "status.mute_conversation": "ਗੱਲਬਾਤ ਨੂੰ ਮੌਨ ਕਰੋ",
  "status.open": "ਇਹ ਪੋਸਟ ਨੂੰ ਫੈਲਾਓ",
  "status.pin": "ਪਰੋਫਾਈਲ ਉੱਤੇ ਟੰਗੋ",
  "status.quote": "ਹਵਾਲਾ",
  "status.quote.cancel": "ਹਵਾਲੇ ਨੂੰ ਰੱਦ ਕਰੋ",
  "status.quote_noun": "ਹਵਾਲਾ",
  "status.quotes_count": "{count, plural, one {{counter} ਹਵਾਲਾ} other {{counter} ਹਵਾਲੇ}}",
  "status.read_more": "ਹੋਰ ਪੜ੍ਹੋ",
  "status.reblog": "ਬੂਸਟ",
  "status.reblog_or_quote": "ਬੂਸਟ ਜਾਂ ਹਵਾਲਾ",
  "status.reblogged_by": "{name} ਨੇ ਬੂਸਟ ਕੀਤਾ",
  "status.reblogs.empty": "No one has boosted this toot yet. When someone does, they will show up here.",
  "status.redraft": "ਹਟਾਓ ਤੇ ਮੁੜ-ਡਰਾਫਟ",
  "status.remove_bookmark": "ਬੁੱਕਮਾਰਕ ਨੂੰ ਹਟਾਓ",
  "status.remove_favourite": "ਮਨਪਸੰਦ ਵਿੱਚੋਂ ਹਟਾਓ",
  "status.remove_quote": "ਹਟਾਓ",
  "status.replied_in_thread": "ਮਾਮਲੇ ਵਿੱਚ ਜਵਾਬ ਦਿਓ",
  "status.replied_to": "{name} ਨੂੰ ਜਵਾਬ ਦਿੱਤਾ",
  "status.reply": "ਜਵਾਬ ਦੇਵੋ",
  "status.replyAll": "ਮਾਮਲੇ ਨੂੰ ਜਵਾਬ ਦਿਓ",
  "status.report": "@{name} ਦੀ ਰਿਪੋਰਟ ਕਰੋ",
  "status.sensitive_warning": "ਸੰਵੇਦਨਸ਼ੀਲ ਸਮੱਗਰੀ",
  "status.share": "ਸਾਂਝਾ ਕਰੋ",
  "status.show_less_all": "ਸਭ ਲਈ ਘੱਟ ਵੇਖਾਓ",
  "status.show_more_all": "ਸਭ ਲਈ ਵੱਧ ਵੇਖਾਓ",
  "status.show_original": "ਅਸਲ ਨੂੰ ਵੇਖਾਓ",
  "status.title.with_attachments": "{user} ਨੇ {attachmentCount, plural,one {ਅਟੈਚਮੈਂਟ} other {{attachmentCount}ਅਟੈਚਮੈਂਟਾਂ}} ਪੋਸਟ ਕੀਤੀਆਂ",
  "status.translate": "ਉਲੱਥਾ ਕਰੋ",
  "status.translated_from_with": "{provider} ਵਰਤ ਕੇ {lang} ਤੋਂ ਅਨੁਵਾਦ ਕੀਤਾ",
  "status.uncached_media_warning": "ਝਲਕ ਮੌਜੂਦ ਨਹੀਂ ਹੈ",
  "status.unpin": "ਪਰੋਫਾਈਲ ਤੋਂ ਲਾਹੋ",
  "subscribed_languages.save": "ਤਬਦੀਲੀਆਂ ਸੰਭਾਲੋ",
  "tabs_bar.home": "ਘਰ",
  "tabs_bar.menu": "ਮੇਨੂ",
  "tabs_bar.notifications": "ਸੂਚਨਾਵਾਂ",
  "tabs_bar.publish": "ਨਵੀਂ ਪੋਸਟ",
  "tabs_bar.search": "ਖੋਜੋ",
  "terms_of_service.title": "ਸੇਵਾ ਦੀਆਂ ਸ਼ਰਤਾਂ",
  "time_remaining.days": "{number, plural, one {# ਦਿਨ} other {# ਦਿਨ}} ਬਾਕੀ",
  "time_remaining.hours": "{number, plural, one {# ਘੰਟਾ} other {# ਘੰਟੇ}} ਬਾਕੀ",
  "time_remaining.minutes": "{number, plural, one {# ਮਿੰਟ} other {# ਮਿੰਟ}} ਬਾਕੀ",
  "trends.counter_by_accounts": "{count, plural, one {{counter} person} other {{counter} people}} in the past {days, plural, one {day} other {# days}}",
  "trends.trending_now": "ਹੁਣ ਰੁਝਾਨ ਵਿੱਚ",
  "units.short.billion": "{count}ਿਬ",
  "units.short.million": "{count}ਮਿ",
  "units.short.thousand": "{count}ਹਜ਼ਾਰ",
  "upload_button.label": "ਚਿੱਤਰ, ਵੀਡੀਓ ਜਾਂ ਆਡੀਓ ਫਾਇਲ ਨੂੰ ਜੋੜੋ",
  "upload_form.edit": "ਸੋਧ",
  "upload_progress.label": "ਅੱਪਲੋਡ ਕੀਤਾ ਜਾ ਰਿਹਾ ਹੈ...",
  "upload_progress.processing": "ਕਾਰਵਾਈ ਚੱਲ ਰਹੀ ਹੈ…",
  "username.taken": "ਉਹ ਵਰਤੋਂਕਾਰ ਨਾਂ ਪਹਿਲਾਂ ਹੀ ਲੈ ਲਿਆ ਹੈ। ਹੋਰ ਅਜ਼ਮਾਓ",
  "video.close": "ਵੀਡੀਓ ਨੂੰ ਬੰਦ ਕਰੋ",
  "video.download": "ਫ਼ਾਈਲ ਨੂੰ ਡਾਊਨਲੋਡ ਕਰੋ",
  "video.exit_fullscreen": "ਪੂਰੀ ਸਕਰੀਨ ਵਿੱਚੋਂ ਬਾਹਰ ਨਿਕਲੋ",
  "video.expand": "ਵੀਡੀਓ ਨੂੰ ਫੈਲਾਓ",
  "video.fullscreen": "ਪੂਰੀ ਸਕਰੀਨ",
  "video.hide": "ਵੀਡੀਓ ਨੂੰ ਲੁਕਾਓ",
  "video.mute": "ਮੌਨ",
  "video.pause": "ਠਹਿਰੋ",
  "video.play": "ਚਲਾਓ",
  "video.skip_backward": "ਛੱਡ ਕੇ ਪਿੱਛੇ ਜਾਓ",
  "video.skip_forward": "ਛੱਡ ਕੇ ਅੱਗੇ ਜਾਓ",
  "video.volume_down": "ਅਵਾਜ਼ ਘਟਾਓ",
  "video.volume_up": "ਅਵਾਜ਼ ਵਧਾਓ",
  "visibility_modal.quote_followers": "ਸਿਰਫ਼ ਫ਼ਾਲੋਅਰ",
  "visibility_modal.quote_label": "ਕੌਣ ਹਵਾਲਾ ਦੇ ਸਕਦਾ ਹੈ",
  "visibility_modal.quote_nobody": "ਸਿਰਫ਼ ਮੈਂ",
  "visibility_modal.quote_public": "ਕੋਈ ਵੀ",
  "visibility_modal.save": "ਸੰਭਾਲੋ"
}
